<template>
  <div id="content">
    <div v-show="isLoading" class="loading-wraper">
      <img
        class="loading"
        src="https://p4-ky.wsukwai.com/udata/pkg/kmovie/fontend-activity/loading.be43c23130aad283.svg"
      />
    </div>
    <div
      v-if="!showDelete"
      ref="app"
      class="app-show-box"
      :style="{ background: ' #' + modelBackgroudColor }"
    >
      <div
        class="app-background-cover"
        :style="{ background: ' #' + modelBackgroudColor }"
      ></div>
      <div class="app-bar-msg">
        <OpenTag
          :openUrl="openUrl"
          logType="try"
          :id="id"
          :shareKey="shareKey"
          :wxShareKey="wxShareKey"
        >
          <img class="img" :src="$t('shareIcon')" />
        </OpenTag>
      </div>
      <div class="app-video-box" v-show="show">
        <TwVideo
          :data="twResources"
          :twMusic="twMusic"
          v-if="produceType === 'TW_TEMPLATE' && twResources.length > 0"
        />
        <Video
          v-else
          class="app-video"
          :width="width"
          :height="height"
          :cover="modelVideoCover"
          :source="modelVideoUrl"
        ></Video>
      </div>
      <div class="app-bottom-fixed" v-show="show">
        <div v-if="!hideUserInfo" class="app-use-msg">
          <div class="app-useinfo">
            <div class="app-headportrait">
              <OpenTag
                :openUrl="openUrl"
                logType="icon"
                :id="id"
                :shareKey="shareKey"
                :wxShareKey="wxShareKey"
              >
                <img class="img" :src="modelUserPic" />
              </OpenTag>
            </div>
            <div class="app-username">{{ modelUserName }}</div>
          </div>

          <div class="app-usecount">
            <div class="title-text">{{ $t("useCount") }}</div>
            <div class="count-text">
              {{ $t("numberFormat", modelUseCount) }}
            </div>
          </div>
        </div>
        <div
          class="app-text"
          :class="{
            'is-tw': produceType === 'TW_TEMPLATE' && twResources.length > 0,
          }"
        >
          <p class="app-text-desc">
            {{ modelDesc }}
          </p>
        </div>
        <div class="app-use-btn">
          <OpenTag
            :openUrl="openUrl"
            :id="id"
            logType="edit"
            :shareKey="shareKey"
            :wxShareKey="wxShareKey"
          >
            <div class="app-use-btn-text">{{ $t("toUse") }}</div>
          </OpenTag>
        </div>
      </div>
      <div v-show="showError" class="app-exit-tip">
        <div class="exit-img"></div>
        <div class="exit-text">
          {{ modelErrorMsg }}
          <br />{{ $t("clickToView") }}
        </div>
      </div>
    </div>
    <span v-show="showDelete">
      <DeleteBlock :openUrl="openUrl" :userId="kyUserId" :id="id" />
    </span>
  </div>
</template>

<script>
import Video from "../../components/Video.vue";
import TwVideo from "../components/TwVideo.vue";
import { getUrlParam } from "@/utils/url";
import { get } from "../utils/utils";
import { wxShareConfig, isWexin } from "@/utils/wx";
import { WebpMachine } from "webp-hero";
import OpenTag from "../../components/OpenTag.vue";
import DeleteBlock from "../components/DeleteBlock.vue";

// 支持webp 格式图片

const webpMachine = new WebpMachine();

export default {
  name: "base-share",
  components: {
    Video,
    OpenTag,
    DeleteBlock,
    TwVideo,
  },
  data() {
    return {
      showDelete: false,
      showError: false,
      id: "",
      show: false,
      modelVideoUrl: "",
      modelName: "",
      modelDesc: "",
      modelVideoCover: "",
      width: 0,
      height: 0,
      modelUserPic: "",
      modelUserName: "",
      modelUseCount: 0,
      modelErrorMsg: "",
      modelBackgroudColor: "",
      isWexin: isWexin,
      openUrl: "",
      isLoading: true,
      pageTag: "kwaiying-template-share",
      shareKey: "MV_SHARE_H5_USE_BTN",
      wxShareKey: "MV_SHARE_H5_USE_WX_LAUNCH",
      kyUserId: "",
      hideUserInfo: false,
      produceType: "",
      twResources: [],
      twMusic: "",
    };
  },
  props: {},
  computed: {
    // 屏幕宽度
    screenWidth() {
      return document.body.clientWidth;
    },

    screenHeight() {
      return document.body.clientHeight;
    },
  },
  methods: {
    async pageInit() {
      this.isLoading = true;
      this.id = getUrlParam("id");
      let from = getUrlParam("from");
      let fromParam = from || "mv_share_h5";
      this.openUrl = this.id
        ? `kwaiying://mv?id=${this.id}&from=${fromParam}`
        : "kwaiying://mv";
      let kyUserId = getUrlParam("kyUserId");
      let taskId = getUrlParam("taskId");
      let share_token = getUrlParam("share_token");
      if (kyUserId && taskId) {
        this.openUrl +=
          (this.id ? "&" : "?") + `taskId=${taskId}&kyUserId=${kyUserId}`; //带上活动任务ID和发起者的快影ID
      }
      if (share_token) {
        this.openUrl += (this.openUrl.includes("?") ? "&" : "?") + `share_token=${share_token}`;
      }
      const { result, resource = {} } = await this.getModelService(this.id);
      if (result === 1 && resource) {
        this.modelName = resource.name;
        this.modelDesc =
          resource.templateBean && resource.templateBean.description;
        this.modelVideoUrl = resource.videoUrl;
        this.modelVideoCover = resource.templateBean.coverUrl;
        this.modelUserPic = resource.user.iconUrlList[0];
        this.modelUserName = resource.user.nickName;
        this.modelUseCount = resource.templateBean.useCount;
        const { w, h } = this.computedVideoSize(resource.templateBean);
        this.width = w;
        this.height = h;
        this.show = true;
        this.produceType = resource.produceType;
        this.twResources = resource.twResources;
        this.twMusic = resource.twMusic;
        // ios兼容webpg格式图片
        if (this.modelVideoCover.indexOf("webp") !== -1) {
          this.modelVideoCover = this.modelVideoCover.indexOf("?")
            ? this.modelVideoCover + ".webp"
            : this.modelVideoCover + "?_webp_type=webp.webp";
          // 增加.webp后缀 webpMachine来识别处理
          webpMachine.polyfillDocument();
        }
        wxShareConfig(
          {
            title: this.modelName,
            desc: this.modelDesc,
            imgUrl: this.modelVideoCover,
          },
          this.pageTag
        );
      }
      if (resource?.deleteStatus === 2) {
        // 2 表示模板删除
        this.kyUserId = resource.user?.userId;
        this.showDelete = true;
      } else if (
        resource?.deleteStatus === 1 &&
        resource.weakDeleteStatus === 2
      ) {
        // 模板弱删除
        this.hideUserInfo = true;
      } else {
        this.modelErrorMsg = this.$t("noTemplate");
        this.showError = true;
      }
      this.isLoading = false;
    },
    // 1280*720
    // 720*1280
    // 720*960
    // 目前有三种尺寸的视频，统一以视频宽度为基准等比缩放
    computedVideoSize({ width, height }) {
      let result = {};
      const CW = document.body.clientWidth;
      // 获得比值
      const per = width / CW;
      result = { w: CW, h: height / per };
      return result;
    },

    async getModelService(templateId) {
      const { data = {} } = await get(
        "/rest/n/kmovie/app/resource/getTemplateById",
        {
          templateId,
          deleteVersion: 1,
        }
      );
      return data;
    },
  },
  async mounted() {
    this.pageInit();
    document.title = this.modelName;
  },
};
</script>

<style lang="less" scoped>
#content {
  text-align: center;
  background-size: cover;
  height: 100vh;
  width: 100vw;
  overflow: hidden;
  position: relative;
  display: flex;
  justify-content: center;
  background-color: rgba(0, 0, 0, 1);
  & > div {
    overflow: hidden;
  }
}

.app-show-box {
  width: 100%;
  max-width: 500px;
  height: 100%;
  box-sizing: border-box;
  position: relative;
}
.img {
  width: 100%;
}

//模板背景
.app-background-cover {
  top: 0;
  z-index: -1;
  position: absolute;
  width: 100%;
  height: 100%;
}
.launch-btn {
  position: absolute;
  left: 0;
  top: 0;
  right: 0;
  bottom: 0;
  z-index: 99;
}
// 模板页头部信息
.app-bar-msg {
  z-index: 9999;
  position: absolute;
  width: 100%;
  height: 1.1rem;
  background: rgba(0, 0, 0, 0.8);
  display: flex;
  justify-content: space-between;
  align-items: center;
}

//视频封面
.app-video-box {
  overflow: hidden;
  height: 100%;
  display: flex;
  align-items: center;
}

.app-video {
  overflow: hidden;
}

//模板页使用信息以及底部button
.app-bottom-fixed {
  width: 100%;
  padding-bottom: 0.96rem;
  position: absolute;
  overflow: hidden;
  bottom: 0;
  left: 0;
  right: 0;
  background: linear-gradient(
    180deg,
    rgba(0, 0, 0, 0),
    rgba(0, 0, 0, 0.1) 42%,
    rgba(0, 0, 0, 0.3)
  );
}

.app-use-msg {
  margin: 0rem 0.5rem;
  height: 1.28rem;
  display: flex;
  justify-content: space-between;
  align-items: center;
  .app-useinfo {
    display: flex;
    justify-content: flex-start;
    align-items: center;
    .app-headportrait {
      width: 0.76rem;
      height: 0.76rem;
      border-radius: 50%;
      overflow: hidden;
      box-shadow: 0 -0.02rem #ffffff, 0.02rem 0 #ffffff, 0 0.02rem #ffffff,
        -0.02rem 0 #ffffff;
      align-items: center;
      display: flex;
    }
    .app-username {
      margin-left: 0.16rem;
      height: 0.38rem;
      font-size: 0.3rem;
      font-family: PingFangSC, PingFangSC-Medium;
      font-weight: 500;
      text-align: left;
      color: #ffffff;
      line-height: 0.38rem;
      text-shadow: 0rem 0.02rem 0.04rem 0rem rgba(0, 0, 0, 0.2);
    }
  }
  .app-usecount {
    padding: 0.13rem 0.28rem;
    background: rgba(0, 0, 0, 0.4);
    border-radius: 0.34rem;
    display: flex;
    justify-content: flex-start;
    align-items: center;
    .title-text {
      margin-right: 0.16rem;
      font-size: 0.22rem;
      font-family: PingFangSC, PingFangSC-Regular;
      font-weight: 400;
      color: #ffffff;
      text-shadow: 0rem 0.02rem 0.04rem 0rem rgba(0, 0, 0, 0.2);
    }
    .count-text {
      font-size: 0.3rem;
      font-family: PingFangSC, PingFangSC-Medium;
      font-weight: 500;
      text-align: right;
      color: #ffffff;
      line-height: 0.38rem;
      text-shadow: 0rem 0.02rem 0.04rem 0rem rgba(0, 0, 0, 0.2);
    }
  }
}

.app-text {
  color: #ffffff;
  margin: 0rem 0.44rem 0.44rem 0.48rem;
  .app-text-desc {
    font-size: 0.24rem;
    font-family: PingFangSC, PingFangSC-Medium;
    font-weight: 500;
    text-align: justify;
    line-height: 0.36rem;
    text-shadow: 0rem 0.02rem 0.04rem 0rem rgba(0, 0, 0, 0.2);
  }
}

.is-tw {
  margin-bottom: 0.82rem;
}

.app-use-btn {
  margin: 0 auto;
  width: 5.28rem;
  height: 1.04rem;
  border-radius: 0.52rem;
  background: linear-gradient(45deg, #f52c6f, #f7365d, #ff5151);
  overflow: hidden;
  color: #fff;
  position: relative;
}

/deep/ .app-use-btn-text {
  text-align: center;
  font-size: 0.4rem;
  line-height: 1.04rem;
}

.app-exit-tip {
  height: 100vh;
  width: 100vw;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  background-size: 100%;
  .exit-img {
    width: 4.8rem;
    height: 3rem;
    background-image: url("https://p4-ky.wsukwai.com/udata/pkg/kmovie/fontend-activity/ky_empty_source.8e152a61dfc81d49.png");
    background-size: 100% 100%;
    margin-bottom: 0.18rem;
  }
  .exit-text {
    width: 4.9rem;
    font-size: 0.26rem;
    font-family: PingFangSC, PingFangSC-Regular;
    font-weight: 400;
    text-align: center;
    color: #666666;
    line-height: 0.4rem;
  }
}
</style>
